
// src/pages/Dashboard.js
import React, { useState, useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import NavigationBar from '../components/NavigationBar';
import Chatbot from '../components/Chatbot';
import {
  Box,
  CssBaseline,
  IconButton,
  Typography,
  Modal,
  Paper,
} from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import { UserContext } from '../context/UserContext';
import DOMPurify from 'dompurify';
// Icons
import InfoIcon from '@mui/icons-material/Info';
import CancelIcon from '@mui/icons-material/Cancel';
// Updated style for a larger MUI modal pop-up
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  width: 'min(600px, 90vw)', // Increased width
  maxHeight: '90vh', // Increased max height
  overflowY: 'auto',
  borderRadius: 2,
};
function Dashboard() {
  const { segmentData } = useContext(UserContext);
  const [openProfile, setOpenProfile] = useState(false);
  // useEffect(() => {
  //    const handlePopState = () => window.history.pushState(null, "", window.location.href);
  //    window.history.pushState(null, "", window.location.href);
  //    window.addEventListener("popstate", handlePopState);
  //    return () => window.removeEventListener("popstate", handlePopState);
  // }, []);
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <CssBaseline />
      <NavigationBar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: 2,
          px: 2,
        }}
      >
        <AnimatePresence mode="wait">
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.5 }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </Box>
      {/* Main Chatbot (unchanged) */}
      {/* <Chatbot /> */}
      {/* Floating Segment Profile Icon at bottom-right (above chatbot) */}
      {/* <Box
        sx={{
          position: 'fixed',
          bottom: 160,
          right: 20,
          zIndex: 9999,
        }}
      >
        {!openProfile && (
          <IconButton
            color="primary"
            onClick={() => setOpenProfile(true)}
            sx={{
              backgroundColor: '#fff',
              boxShadow: 3,
              width: 56,
              height: 56,
              borderRadius: '50%',
              '&:hover': {
                backgroundColor: '#f0f0f0',
              },
            }}
          >
            <InfoIcon fontSize="medium" />
          </IconButton>
        )}
      </Box> */}
      {/* MUI Modal for Segment Profile */}
      <Modal
        open={openProfile}
        onClose={() => setOpenProfile(false)}
        aria-labelledby="segment-profile-title"
        aria-describedby="segment-profile-description"
      >
        <Box sx={modalStyle}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 1,
            }}
          >
            <Typography
              id="segment-profile-title"
              variant="h6"
              component="h2"
              sx={{ fontWeight: 'bold' }}
            >
              Segment Profile
            </Typography>
            <IconButton
              size="small"
              onClick={() => setOpenProfile(false)}
              sx={{ color: 'grey.700' }}
            >
              <CancelIcon fontSize="small" />
            </IconButton>
          </Box>
          {segmentData ? (
            <>
              <Typography
                id="segment-profile-description"
                variant="body2"
                sx={{ mb: 2 }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(segmentData.description || ''),
                }}
              />
              {segmentData.image && (
                <Paper variant="outlined" sx={{ p: 1 }}>
                  <img
                    src={`http://localhost:8000${segmentData.image}`}
                    alt="Segment"
                    style={{ maxWidth: '100%', display: 'block', margin: '0 auto' }}
                  />
                </Paper>
              )}
            </>
          ) : (
            <Typography variant="body2" sx={{ mb: 2 }}>
              No segment data to display yet.
            </Typography>
          )}
        </Box>
      </Modal>
    </Box>
  );
}
export default Dashboard;